export default __webpack_public_path__ + "static/SRUS HPH400 - Product Specifications & Technical Data-dd73434531ce3158123bb3eba408a6cd.pdf";